const TOAST_EVENT = 'chse-app-toast';

export function publishAppToast(message, type = 'error') {
  if (!message || typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(TOAST_EVENT, {
      detail: { message, type },
    })
  );
}

export function subscribeAppToast(handler) {
  if (typeof window === 'undefined') return () => {};

  const listener = (event) => {
    handler(event.detail);
  };

  window.addEventListener(TOAST_EVENT, listener);
  return () => window.removeEventListener(TOAST_EVENT, listener);
}

export function installPlaybackErrorHandlers() {
  if (typeof window === 'undefined') return;

  const shouldHandle = (message) => {
    const normalized = String(message || '').toLowerCase();
    return (
      normalized.includes('otp') ||
      normalized.includes('vdocipher') ||
      normalized.includes('failed to generate') ||
      normalized.includes('playback')
    );
  };

  window.addEventListener('unhandledrejection', (event) => {
    const message =
      event?.reason?.message || (typeof event?.reason === 'string' ? event.reason : '');
    if (!shouldHandle(message)) return;
    event.preventDefault();
    publishAppToast(message, 'error');
  });

  window.addEventListener('error', (event) => {
    if (!shouldHandle(event?.message)) return;
    event.preventDefault();
    publishAppToast(event.message, 'error');
    return true;
  });
}
